import React from 'react';
import { ProductSection } from './ProductSection';
import BucketComponent from './BucketComponent';

const renderers = {
  // eslint-disable-next-line react/display-name
  JoinBucket: (bucket, setRootBucket, rootBucket) => (
    <BucketComponent
      key={bucket.bucketId}
      bucket={bucket}
      setRootBucket={setRootBucket}
      rootBucket={rootBucket}
    />
  ),
  // eslint-disable-next-line react/display-name
  ProductBucket: (bucket, setRootBucket, rootBucket) => (
    <ProductSection
      key={bucket.bucketId}
      setRootBucket={setRootBucket}
      bucket={bucket}
      rootBucket={rootBucket}
    />
  ),
  // eslint-disable-next-line react/display-name
  ProductFamilyBucket: (bucket, setRootBucket, rootBucket) => (
    <ProductSection
      key={bucket.bucketId}
      setRootBucket={setRootBucket}
      bucket={bucket}
      rootBucket={rootBucket}
    />
  ),
  // eslint-disable-next-line react/display-name
  Bucket: (bucket, setRootBucket, rootBucket) => (
    <ProductSection
      setRootBucket={setRootBucket}
      bucket={bucket}
      rootBucket={rootBucket}
    />
  )
};

export default renderers;
